// removed by extract-text-webpack-plugin
module.exports = {"root":"_1csK_0e","heading":"_1_1_gw3","ul":"TMVT1fQ","li":"_2-euoH3"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/PageNotFound/PageNotFound.less
 ** module id = 889
 ** module chunks = 0
 **/